/**
 * Toggles `.navbar--scrolled` class on
 * window scroll event.
 * @unused
 */
// export const toggleNavbarClassOnScroll = () => {
// 	const navbar = document.getElementById( 'main-nav' );
// 	if ( ! navbar ) {
// 		return;
// 	}

// 	const scrolledClass = 'navbar--scrolled';
// 	window.onscroll = ( e ) => {
// 		const hasClass = navbar.classList.contains( scrolledClass );
// 		if ( window.scrollY > 0 ) {
// 			if ( ! hasClass ) {
// 				navbar.classList.add( scrolledClass );
// 			}
// 		} else if ( hasClass ) {
// 			navbar.classList.remove( scrolledClass );
// 		}
// 	};
// };

export const watchNavbarMenu = () => {
	const navbar = document.getElementById( 'main-nav' );
	if ( ! navbar ) {
		return;
	}
	const navbarCollapse = document.getElementById( 'navbar-collapse' );

	const menuOpenClass = 'navbar--menu-open';
	navbarCollapse.addEventListener( 'show.bs.collapse', () => {
		navbar.classList.add( menuOpenClass );
	} );
	navbarCollapse.addEventListener( 'hide.bs.collapse', () =>
		navbar.classList.remove( menuOpenClass )
	);

	const firstChildLink = navbarCollapse.querySelector( '.dropdown-toggle' );
	const activeMenuItem = navbarCollapse.querySelector(
		'[data-current-menu="true"]'
	);
	navbarCollapse.addEventListener( 'shown.bs.collapse', () => {
		( activeMenuItem || firstChildLink ).click();
	} );

	const collapseInstance = new bootstrap.Collapse( navbarCollapse, {
		toggle: false,
	} );
	document.addEventListener( 'click', ( e ) => {
		if (
			navbar.classList.contains( menuOpenClass ) &&
			! navbarCollapse.contains( e.target )
		) {
			collapseInstance.hide();
		}
	} );
};

export const watchDropdownMenuItems = () => {
	const menus = document.querySelectorAll( '.navbar .dropdown-menu' );
	menus.forEach( ( menu ) => {
		const image = menu.querySelector( '.dropdown-menu-image' );
		const links = menu.querySelectorAll( '.dropdown-item[data-img-src]' );
		links.forEach( ( link ) => {
			const imgSrc = link.dataset.imgSrc;
			if ( imgSrc ) {
				preloadImage( imgSrc );
				link.onmouseenter = () => ( image.src = imgSrc );
			}
		} );
	} );
};

// Preload nav images so hover delay doesn't occur
function preloadImage( imgSrc ) {
	const preloadEl = document.createElement( 'link' );
	preloadEl.href = imgSrc;
	preloadEl.as = 'image';
	preloadEl.rel = 'preload';
	document.head.append( preloadEl );
}
